import React from 'react';
import { Grid } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { EmailInput, PasswordInput } from 'library';
import FormSection from './FormSection';

interface AccountSectionProps {
    email: string;
    isEmail: boolean;
    onEmailChange: (value: string, isValid: boolean) => void;
    password: string;
    isPassword: boolean;
    passwordErrorText: string;
    onPasswordChange: (value: string, isValid: boolean) => void;
    expanded: boolean;
    complete: boolean;
    onToggle: () => void;
    onNext: () => void;
}

export default function AccountSection({
    email,
    isEmail,
    onEmailChange,
    password,
    isPassword,
    passwordErrorText,
    onPasswordChange,
    expanded,
    complete,
    onToggle,
    onNext,
}: AccountSectionProps) {
    return (
        <FormSection
            title="Account"
            subtitle="Create your login credentials"
            icon={<LockIcon />}
            expanded={expanded}
            complete={complete}
            onToggle={onToggle}
            onNext={onNext}
            autoFocusId="signup-email"
        >
            <Grid item sm={6} xs={12}>
                <EmailInput
                    id="signup-email"
                    value={email}
                    error={!isEmail}
                    errorText="Please enter your email"
                    label="Email*"
                    onChange={onEmailChange}
                />
            </Grid>
            <Grid item sm={6} xs={12}>
                <PasswordInput
                    id="signup-password"
                    error={!isPassword}
                    errorText={passwordErrorText}
                    value={password}
                    label="Create Password*"
                    onChange={onPasswordChange}
                />
            </Grid>
        </FormSection>
    );
}
